module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message.show) ? _c('div', {
    staticClass: "message_layer"
  }, [_c('div', {
    staticClass: "message_box"
  }, [_c('span', [_vm._v(_vm._s(_vm.message.content))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dbddb30","hasScoped":true}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/pl_message/template.vue
// module id = nuUR
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14